//import Vue from 'vue'
import moment from 'moment'
import COMMON from '@/plugins/handsontable_common'

const _DATA = () => {
    // INSURANCE_TABLE
    const DATA = {}
    DATA.METHODS = {
        data2JsonObject: (data) => {
            return data
                .map((v) => {
                    let data = {}
                    for (let i = 0; i < DATA.FIELDS_ALL.length; i++) {
                        data[DATA.FIELDS_ALL[i].name] = DATA.FIELDS_ALL[i].get(v[i], v)
                    }
                    return data
                })
        },
        sourceCouriers: () => {
            return {
                'dhl': 'DHL',
                'fedex': 'FedEx',
                'ups': 'UPS',
                'japanpost': 'EMS/飛脚GP便',
                'ecms': 'ECMS',
                'orangeconnex': 'OrangeConnex',
            }
        },
        sourceCurrencies: () => {
            return {
                'JPY': '日本円',
                'USD': '米ドル',
                'EUR': 'ユーロ',
                'GBP': 'イギリスポンド',
                'AUD': 'オーストラリアドル',
                'CAD': 'カナダドル',
                'MXN': 'メキシコ・ペソ',
                'CNY': '中国元',
                'KRW': '韓国ウォン',
                'SGD': 'シンガポール・ドル',
                'HKD': '香港ドル',
                'CHF': 'スイスフラン',
                'SEK': 'スウェーデン・クローナ',
                'IDR': 'インドネシア・ルピア',
                'NOK': 'ノルウェー・クローネ',
                'PKR': 'パキスタン・ルピー',
                'PHP': 'フィリピン・ペソ',
                'QAR': 'カタール・リヤル',
                'THB': 'タイ・バーツ',
                'AED': 'ＵＡＥ・ディルハム',
                'INR': 'インド・ルピー',
                'SAR': 'サウジアラビア・リヤル',
                'KWD': 'クウェート・ディナール',
                'NZD': 'ニュージーランド・ドル',
                'ZAR': '南アフリカ・ランド',
                'CZK': 'チェコ・コルナ',
                'TRY': 'トルコ・リラ',
                'RUB': 'ロシア・ルーブル',
                'HUF': 'ハンガリー・フォリント',
                'PLN': 'ポーランド・ズロチ',
                'DKK': 'デンマーク・クローネ',
            }
        },
    }
    // INSURANCE_TABLE
    DATA.RENDERERS = {
        shipping_courier: (instance, td, row, col, prop, value, cellProperties) => {
            const obj = DATA.METHODS.data2JsonObject([ instance.getDataAtRow(row) ])[0]
        
            td.innerText = ''
            if (!value) {
                return td
            }
        
            const span = document.createElement('span')
            span.innerText = DATA.METHODS.sourceCouriers()[value]
            td.appendChild(span)
            return td
        },
        shipping_tracking_codes: (instance, td, row, col, prop, value, cellProperties) => {
            const obj = DATA.METHODS.data2JsonObject([ instance.getDataAtRow(row) ])[0]
        
            td.innerText = ''
            if (!value) {
                return td
            }
        
            const a = document.createElement('a')
            a.href = 'https://t.17track.net/ja#nums=' + value.split("\n").join(',')
            switch (obj.shipping_courier) {
                case 'fedex':
                    a.href += '&fc=100003'
                    break
                case 'ups':
                    a.href += '&fc=100002'
                    break
                case 'dhl':
                    a.href += '&fc=100001'
                    break
                case 'japanpost':
                    a.href += '&fc=10021'
                    break
                case 'ecms':
                    a.href += '&fc=190168'
                    break
                case 'orangeconnex':
                    a.href += '&fc=190205'
                    break
            }
            a.target = '_blank'
            a.innerText = value
            td.appendChild(a)
            return td
        },
        shipping_item_currency: (instance, td, row, col, prop, value, cellProperties) => {
            const obj = DATA.METHODS.data2JsonObject([ instance.getDataAtRow(row) ])[0]
        
            td.innerText = ''
            if (!value) {
                return td
            }
        
            const span = document.createElement('span')
            span.innerText = value
//            span.innerText = DATA.METHODS.sourceCurrencies()[value]
            td.appendChild(span)
            return td
        },
    }
    // INSURANCE_TABLE
    DATA.FIELDS = {
        // システム入力
        SYSTEM: [
            {
                name: 'id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.id },
                colHeader: 'システム<br>Tuskey保険番号',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
            {
                name: 'created_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.created_at },
                colHeader: '作成日',
                column: {
                    renderer: COMMON().RENDERERS.YYYY_MM_DD,
                },
                readOnly: true,
            },
            {
                name: 'user_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.user_id },
                colHeader: 'ユーザーID(数字)',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
            {
                name: 'status',
                get: (v, v_all) => { return v },
                load: (v) => { return v.status },
                colHeader: '状態',
                column: {
                    type: 'text',
                    renderer: COMMON().RENDERERS.status,
                },
                readOnly: true,
            },
            {
                name: 'shipping_tracking_log',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_tracking_log },
                colHeader: '追跡情報',
                column: {
                    type: 'text',
                    renderer: COMMON().RENDERERS.shipping_tracking_log,
                },
            },
            {
                name: 'shipping_tracking_confirmed_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_tracking_confirmed_at },
                colHeader: '追跡有効確認日時',
                column: {
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD HH:mm',
                    correctFormat: true,
                },
            },
            {
                name: 'shipping_insurance_charge',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_insurance_charge },
                colHeader: '保険料(JPY)',
                column: {
                    type: 'numeric',
                    numericFormat: {
                        pattern: '0,0',
                    },
                },
                readOnly: true,
            },
        ],
        SYSTEM_UPDATED_AT: [
            {
                name: 'updated_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.updated_at },
                colHeader: 'updated_at',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
        ],
        // 登記
        PROFILE: [
            {
                name: 'profile_representative',
                get: (v, v_all) => { return v },
                load: (v) => { return v.profile_representative },
                colHeader: '登記<br>氏名<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'profile_company',
                get: (v, v_all) => { return v },
                load: (v) => { return v.profile_company },
                colHeader: '会社名/屋号<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'profile_address',
                get: (v, v_all) => { return v },
                load: (v) => { return v.profile_address },
                colHeader: '住所<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'profile_tel',
                get: (v, v_all) => { return v },
                load: (v) => { return v.profile_tel },
                colHeader: '電話<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'profile_email',
                get: (v, v_all) => { return v },
                load: (v) => { return v.profile_email },
                colHeader: 'メール<i class="required" />',
                column: {
                    type: 'text',
                },
            },
        ],
        // 発送人
        FROM: [
            {
                name: 'from_representative',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_representative },
                colHeader: '発送人<br>氏名(en)<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_company',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_company },
                colHeader: '会社名/屋号(en)<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_address',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_address },
                colHeader: '住所(en)<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_tel',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_tel },
                colHeader: '電話<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_email',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_email },
                colHeader: 'メール<i class="required" />',
                column: {
                    type: 'text',
                },
            },
        ],
        // 受取人
        TO: [
            {
                name: 'to_representative',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_representative },
                colHeader: '受取人<br>担当者名(en)<i class="required" />',
                column: {
                    type: 'text',
                },
            },
//            {
//                name: 'to_company',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.to_company },
//                colHeader: '会社名/屋号',
//                column: {
//                    type: 'text',
//                },
//            },
            {
                name: 'to_line1',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_line1 },
                colHeader: 'Address Line1<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_line2',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_line2 },
                colHeader: 'Address Line2',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_city',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_city },
                colHeader: 'City<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_state',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_state },
                colHeader: 'State Or Region<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_zip',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_zip },
                colHeader: 'Postal Code<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_country',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_country },
                colHeader: 'Country<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_tel',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_tel },
                colHeader: '電話<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_email',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_email },
                colHeader: 'メール',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_tax_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_tax_id },
                colHeader: 'TAX ID',
                column: {
                    type: 'text',
                },
            },
        ],
        // 発送情報
        SHIPPING: [
            {
                name: 'shipping_courier',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_courier },
                colHeader: '発送情報<br>クーリエ<i class="required" />',
                column: {
                    type: 'dropdown',
                    source: Object.keys(DATA.METHODS.sourceCouriers()),
                    renderer: DATA.RENDERERS.shipping_courier,
                },
            },
            {
                name: 'shipping_invoice_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_invoice_id },
                colHeader: 'Invoice番号',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_tracking_codes',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_tracking_codes },
                colHeader: '追跡番号<i class="required" />',
                column: {
                    type: 'text',
                    renderer: DATA.RENDERERS.shipping_tracking_codes,
                },
            },
            {
                name: 'shipping_item_quantity',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_item_quantity },
                colHeader: '数量<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: COMMON().RENDERERS.numeric,
                },
            },
            {
                name: 'shipping_item_hs_code',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_item_hs_code },
                colHeader: 'HS Code',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_item_country',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_item_country },
                colHeader: '原産国(en)<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_item_name',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_item_name },
                colHeader: '申告商品名（en）<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_item_currency',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_item_currency },
                colHeader: '通貨<i class="required" />',
                column: {
                    type: 'dropdown',
                    source: Object.keys(DATA.METHODS.sourceCurrencies()),
                    renderer: DATA.RENDERERS.shipping_item_currency,
                },
            },
            {
                name: 'shipping_item_price',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_item_price },
                colHeader: '単価<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: COMMON().RENDERERS.numeric,
                },
            },
            {
                name: 'shipping_item_price_total',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_item_price_total },
                colHeader: '申告金額＝保険金額(JPY)<i class="required" />',
                column: {
                    type: 'numeric',
                    renderer: COMMON().RENDERERS.numeric,
                    className: 'text-right',
                },
                readOnly: true,
            },
            {
                name: 'shipping_label_issued_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_label_issued_at },
                colHeader: 'ラベル発行日時',
                column: {
                    type: 'date',
                    dateFormat: 'YYYY-MM-DD',
                },
            },
        ],
    }
    DATA.FIELDS_ALL =
        DATA.FIELDS.SYSTEM
        .concat(DATA.FIELDS.SYSTEM_UPDATED_AT)
        .concat(DATA.FIELDS.PROFILE)
        .concat(DATA.FIELDS.FROM)
        .concat(DATA.FIELDS.TO)
        .concat(DATA.FIELDS.SHIPPING)
    return DATA
}

export default _DATA

